module.exports = __webpack_public_path__ + "img/172621_user_female_icon.c24bc6d4.svg";